
import logo from '../assets/logo-f.png';
import profile from '../assets/profile.png';
import yo from '../assets/yoart.png';
import circle from '../assets/circle.svg';
import flutter from '../assets/flutter.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import react from '../assets/react.png';
import js from '../assets/js.png';
import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import email from '../assets/email.png';
import mobile from '../assets/mobile.png';


export default {
  logo,
  profile,
  yo,
  circle,
  flutter, 
  redux,
  sass,
  react,
  js,
  about01,
  about02,
  about03,
  email,
  mobile,
};      